import { render, staticRenderFns } from "./DxPopupWorkOrder.vue?vue&type=template&id=1987e83e&scoped=true&"
import script from "./DxPopupWorkOrder.vue?vue&type=script&lang=js&"
export * from "./DxPopupWorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./DxPopupWorkOrder.vue?vue&type=style&index=0&id=1987e83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987e83e",
  null
  
)

export default component.exports